<template>
    <div>
        <a
            class="avatar profile-avatar-sizing avatar-circle avatar-border-lg avatar-uploader profile-cover-avatar ml-4"
            style="margin: calc(104px / -2) 0;"
            role="button"
            data-toggle="modal"
            data-target="#profilePictureModificationModal"
            @click.prevent="editProfilePicture(userForm)"
        >
            <img
                class="avatar-img w-100"
                :src="newImageUrl || src"
                :alt="alt"
            >
            <span class="avatar-uploader-trigger z-index-2">
                <i class="fal fa-pen avatar-uploader-icon shadow-soft text-info d-flex"></i>
            </span>
        </a>
        <form-profile-picture ref="modalFormProfilePicture" @image-selected="onImageSelected"/>
    </div>
</template>

<script>
export default {
    props: {
        src: {
            type: String,
            required: true,
        },
        alt: {
            type: String,
            default: '',
        },
        userForm: {
            type: Object,
            required: true,
        },
    },
    data () {
        return {
            newImageUrl: null,
        };
    },
    methods: {
        async editProfilePicture (userForm) {
            const {_delete, ...params} = await this.$refs.modalFormProfilePicture.open({
                userForm: {...userForm, profilePictureUrl: this.src, isProfilePictureSet: !!this.userForm.profilepicture_set_at},
                callback: async ({_delete, form}) => {
                    if (_delete) {
                        // TODO : delete
                        return;
                    }
                    this.newImageUrl = form.get('url');
                },
            });
            if (params === false) {
                // dismissed
                return;
            }
        },
        onImageSelected(image) {
            const fileInput = document.getElementById('file-input');
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(image);
            fileInput.files = dataTransfer.files;
        }
    }
};
</script>
